var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { appModuleAnimation } from '../animations/routerTransition';
import { Component, ViewEncapsulation, Input, ViewChild } from '@angular/core';
import { ConfigureComponentBase } from '../../../shared/configure-component-base';
import { TabDirective } from 'ngx-bootstrap';
import * as _ from 'lodash';
import { finalize } from 'rxjs/operators';
import { AutoRenameTypeEnum } from '../data-configuration/configuration/variable/batch-import-modal/auto-rename-type-enum';
import { RenameVariableOrAlarmModalComponent } from './rename-modal/rename-variable-or-alarm-modal.component';
import { ActiveTabIndexEnum } from './shared/active-tab-index-enum';
import { DataSourceDto, ImportFromFBoxDto, BuildDataAfterImportDto, CreateOrUpdateDataSourceImportInfoDto } from '../../../shared/service-proxies/service-proxies';
import { CreateOrEditDataSourceModalComponent } from './create-or-edit-data-source-modal/create-or-edit-data-source-modal.component';
import { DataSourceType } from './shared/data-source-type-enum';
var DataSourceConfigurationComponent = /** @class */ (function (_super) {
    __extends(DataSourceConfigurationComponent, _super);
    function DataSourceConfigurationComponent(injector, modalService, boxAccountService, fBoxAccountSettingsService, dataSourceProxy) {
        var _this = _super.call(this, injector) || this;
        _this.modalService = modalService;
        _this.boxAccountService = boxAccountService;
        _this.fBoxAccountSettingsService = fBoxAccountSettingsService;
        _this.dataSourceProxy = dataSourceProxy;
        _this.dataSources = new Array();
        _this.selectedDataSource = new DataSourceDto();
        _this.activeTabIndex = 0;
        _this.busy = true;
        _this.operationsLeft = 0;
        _this.operationsTop = 0;
        return _this;
    }
    DataSourceConfigurationComponent.prototype.ngOnInit = function () {
        this.loadDataSources();
    };
    DataSourceConfigurationComponent.prototype.activeTab = function (ev, tabIndex) {
        if (!(ev instanceof TabDirective)) {
            return;
        }
        this.activeTabIndex = tabIndex;
    };
    DataSourceConfigurationComponent.prototype.openImportBoxDataModalClick = function () {
        this.openImportBoxDataModal();
    };
    DataSourceConfigurationComponent.prototype.loadDataSources = function (isAdd) {
        var _this = this;
        this.busy = true;
        this.dataSourceProxy.getDataSourcesByConfigureId(this.configureId).subscribe(function (data) {
            _this.dataSources = data || [];
            if (_this.selectedDataSource && _this.selectedDataSource.id) {
                var selectedDataSource = _this.dataSources.find(function (x) { return x.id === _this.selectedDataSource.id; });
                if (selectedDataSource) {
                    _this.selectedDataSource = selectedDataSource;
                }
            }
            _this.busy = false;
            if (isAdd) {
                setTimeout(function () {
                    _this.dataSourceListBody.nativeElement.scrollTop = _this.dataSourceListBody.nativeElement.scrollHeight;
                });
            }
            _this.setDefaultSelected();
        });
    };
    DataSourceConfigurationComponent.prototype.setDefaultSelected = function () {
        var _this = this;
        if (this.dataSources.length === 0) {
            return;
        }
        if (this.dataSources.find(function (r) { return r.id === _this.selectedDataSource.id; })) {
            return;
        }
        this.select(this.dataSources[0]);
    };
    DataSourceConfigurationComponent.prototype.select = function (dataSource) {
        this.selectedDataSource = dataSource;
    };
    DataSourceConfigurationComponent.prototype.showMoreOperation = function (event) {
        event.stopPropagation();
        var currentTarget = $(event.currentTarget);
        var isShowMode = currentTarget.next().is(':hidden');
        if (isShowMode) {
            currentTarget.addClass('active');
            currentTarget.next().show(300);
            this.operationsLeft = currentTarget.offset().left;
            this.operationsTop = currentTarget.offset().top + 32;
            if (this.operationsTop + 74 > $('body').height()) {
                this.operationsTop = currentTarget.offset().top - 74;
            }
            document.addEventListener('click', function () {
                currentTarget.removeClass('active');
            });
        }
        else {
            currentTarget.next().hide(300);
        }
    };
    DataSourceConfigurationComponent.prototype.selectDataSource = function (dataSource) {
        this.selectedDataSource = dataSource;
    };
    DataSourceConfigurationComponent.prototype.create = function () {
        var newItem = new DataSourceDto();
        newItem.configureId = this.configureId;
        this.openCreateOrEditDataSourceModel(newItem);
    };
    DataSourceConfigurationComponent.prototype.edit = function (event, dataSource) {
        event.stopPropagation();
        this.openCreateOrEditDataSourceModel(dataSource);
    };
    DataSourceConfigurationComponent.prototype.rename = function (dataSource) {
        this.openCreateOrEditDataSourceModel(_.clone(dataSource));
    };
    DataSourceConfigurationComponent.prototype.openCreateOrEditDataSourceModel = function (dataSource) {
        var _this = this;
        var modalRef = this.modalService.show(CreateOrEditDataSourceModalComponent, {
            initialState: {
                dataSourceCopy: dataSource
            },
            backdrop: 'static', class: 'create-save-data-source-modal'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (result.dataSourceId) {
                _this.selectedDataSource.id = result.dataSourceId;
            }
            if (result.isImport) {
                _this.reloadAndImportBoxData();
            }
            else {
                _this.reloadDatasource(true);
            }
            onClosedSub.unsubscribe();
        });
    };
    DataSourceConfigurationComponent.prototype.reloadDatasource = function (isAdd) {
        this.loadDataSources(isAdd);
    };
    DataSourceConfigurationComponent.prototype.reloadAndImportBoxData = function () {
        this.loadDataSources(true);
        this.openImportBoxDataModal();
    };
    DataSourceConfigurationComponent.prototype.openImportBoxDataModal = function () {
        var _this = this;
        this.fBoxAccountSettingsService.hasTenantFBoxAccount().subscribe(function (hasFBoxAccount) {
            if (hasFBoxAccount) {
                _this.modal.show(_this.selectedDataSource.id);
            }
            else {
                _this.checkFBoxAccountIsConfigured();
            }
        });
    };
    DataSourceConfigurationComponent.prototype.checkFBoxAccountIsConfigured = function () {
        this.fboxAccountWarningModal.showWaring();
    };
    DataSourceConfigurationComponent.prototype.importFromBox = function ($event) {
        var input = new ImportFromFBoxDto();
        input = Object.assign(input, $event.boxAccount);
        input.dataSourceId = this.selectedDataSource.id;
        input.configureId = Number(this.configureId);
        input.dataSourceType = DataSourceType.FBox.valueOf();
        this.dataSourceImport(input, false);
    };
    DataSourceConfigurationComponent.prototype.importFromBoxAndGenerate = function ($event) {
        var input = new ImportFromFBoxDto();
        input = Object.assign(input, $event.boxAccount);
        input.dataSourceId = this.selectedDataSource.id;
        input.configureId = Number(this.configureId);
        input.dataSourceType = DataSourceType.FBox.valueOf();
        this.dataSourceImport(input, true);
    };
    DataSourceConfigurationComponent.prototype.dataSourceImport = function (input, isBuildData) {
        var _this = this;
        abp.ui.setBusy();
        this.dataSourceProxy.dataSourceImport(input).pipe(finalize(function () {
            abp.ui.clearBusy();
            _this.modal.importing = false;
        })).subscribe(function () {
            if (isBuildData) {
                _this.buildDataAfterImport(input);
            }
            else {
                _this.reloadDataSource(input);
            }
        });
    };
    DataSourceConfigurationComponent.prototype.buildDataAfterImport = function (input) {
        var _this = this;
        this.dataSourceProxy.buildDataAfterImportCheckVariableOrAlarmNameRepeat({
            configureId: +this.configureId,
            dataSourceId: input.dataSourceId.valueOf(),
            dataSourceType: input.dataSourceType.valueOf()
        }).pipe(finalize(function () {
            abp.ui.clearBusy();
            _this.modal.importing = false;
        })).subscribe(function (result) {
            var buildInput = new BuildDataAfterImportDto();
            buildInput.configureId = Number(_this.configureId);
            buildInput.dataSourceType = input.dataSourceType.valueOf();
            buildInput.dataSourceId = input.dataSourceId.valueOf();
            buildInput.dataSourceName = _this.dataSources.find(function (res) { return res.id === +input.dataSourceId; }).displayName;
            buildInput.renameType = AutoRenameTypeEnum.None.valueOf();
            //     根据返回的是否具有重名来决定是否提示重名提示
            if (result) {
                //      缓存input提示,目的在回调后调用reloadDataSource方法
                _this.importFromFBoxDto = input;
                _this.openRenameVariableOrAlarmModal(buildInput);
                return;
            }
            _this.dataSourceProxy.buildDataAfterImport(buildInput).pipe(finalize(function () {
                abp.ui.clearBusy();
                _this.modal.importing = false;
            })).subscribe(function () {
                _this.reloadDataSource(input);
            });
        });
    };
    DataSourceConfigurationComponent.prototype.openRenameVariableOrAlarmModal = function (buildInput) {
        var _this = this;
        var modalRef = this.modalService.show(RenameVariableOrAlarmModalComponent, {
            initialState: {
                buildDataAfterImportDto: buildInput,
                configureId: this.configureId
            },
            backdrop: 'static', class: 'rename-variable-or-alarm-modal'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function () {
            _this.reloadDataSource(_this.importFromFBoxDto);
            onClosedSub.unsubscribe();
        });
    };
    DataSourceConfigurationComponent.prototype.reloadDataSource = function (input) {
        var _this = this;
        var createOrUpdateDataSourceImportInfoDto = new CreateOrUpdateDataSourceImportInfoDto();
        this.boxAccountService.createOrUpdateDataSourceImportInfo(Object.assign(createOrUpdateDataSourceImportInfoDto, input))
            .subscribe(function () {
            // 刷新左边的数据源
            _this.loadDataSources();
            _this.modal.close();
            abp.event.trigger('dataSource.add');
            switch (+_this.activeTabIndex) {
                case ActiveTabIndexEnum.VariableView:
                    if (_this.rawVariableView) {
                        _this.rawVariableView.loadFBoxVariablesData();
                    }
                    break;
                case ActiveTabIndexEnum.AlarmView:
                    if (_this.rawAlarmRegistrationView) {
                        _this.rawAlarmRegistrationView.loadFBoxAlarmData();
                    }
                    break;
                case ActiveTabIndexEnum.HistoryDataView:
                    if (_this.rawHistoryDataView) {
                        _this.rawHistoryDataView.loadFBoxHistoryData();
                    }
                    break;
                case ActiveTabIndexEnum.EdgeComputing:
                    if (_this.rawEdgeComputing) {
                        _this.rawEdgeComputing.loadFBoxMacroExecutePlan();
                    }
                    break;
            }
            _this.notify.info(_this.lc('ImportSuccessfully'));
        });
    };
    DataSourceConfigurationComponent.prototype.delete = function (event, dataSource) {
        var _this = this;
        event.stopPropagation();
        this.message.confirm(this.lc('SureToDeleteDataSource', dataSource.displayName, this.appSession.fBoxAlias), function (isConfirmed) {
            if (isConfirmed) {
                _this.dataSourceProxy.deleteDataSource(dataSource.id).subscribe(function () {
                    _this.notify.info(_this.l('SuccessfullyDeleted'));
                    _.remove(_this.dataSources, function (p) {
                        return p.id === dataSource.id;
                    });
                    _this.busy = false;
                    _this.setDefaultSelected();
                    abp.event.trigger('dataSource.delete');
                });
            }
        });
    };
    __decorate([
        Input()
    ], DataSourceConfigurationComponent.prototype, "configureId", void 0);
    __decorate([
        ViewChild('fboxAccountWarningModal', { static: false })
    ], DataSourceConfigurationComponent.prototype, "fboxAccountWarningModal", void 0);
    __decorate([
        ViewChild('importBoxDataModal', { static: false })
    ], DataSourceConfigurationComponent.prototype, "modal", void 0);
    __decorate([
        ViewChild('rawVariableView', { static: false })
    ], DataSourceConfigurationComponent.prototype, "rawVariableView", void 0);
    __decorate([
        ViewChild('rawAlarmRegistrationView', { static: false })
    ], DataSourceConfigurationComponent.prototype, "rawAlarmRegistrationView", void 0);
    __decorate([
        ViewChild('rawHistoryDataView', { static: false })
    ], DataSourceConfigurationComponent.prototype, "rawHistoryDataView", void 0);
    __decorate([
        ViewChild('rawEdgeComputing', { static: false })
    ], DataSourceConfigurationComponent.prototype, "rawEdgeComputing", void 0);
    __decorate([
        ViewChild('dataSourceListBody', { static: true })
    ], DataSourceConfigurationComponent.prototype, "dataSourceListBody", void 0);
    DataSourceConfigurationComponent = __decorate([
        Component({
            selector: 'data-source-configuration',
            template: "<div class=\"design-data-source-configuration\"> <div class=\"data-source-table-container clearfix\"> <div class=\"data-source-list\"> <div class=\"data-source-list-title\"> <span>{{lc('DataSource')}}</span> </div> <div class=\"data-source-list-content\"> <div class=\"scroll-body\"> <div class=\"add-data-source\" (click)=\"create()\"> <span>{{lc('AddDataSource')}}</span> </div> <div class=\"data-source-list-body\" #dataSourceListBody> <div *ngFor=\"let dataSource of dataSources\" class=\"data-source clearfix\" (click)=\"selectDataSource(dataSource)\" [ngClass]=\"{'active': selectedDataSource.id === dataSource.id }\"> <a class=\"data-source-name\" title=\"{{dataSource.displayName}}\">{{dataSource.displayName}}</a> <div class=\"icon\" (click)=\"showMoreOperation($event)\"> <i class=\"fcloud-more\"></i> </div> <div class=\"operations\" [style.left.px]=\"operationsLeft\" [style.top.px]=\"operationsTop\"> <nav> <div (click)=\"rename(dataSource)\">{{lc('Rename')}}</div> <div (click)=\"delete($event,dataSource)\">{{lc('Delete')}}</div> </nav> </div> </div> </div> </div> </div> </div> <div class=\"data-source-content\" [busyIf]=\"busy\"> <div class=\"has-data-source\" *ngIf=\"dataSources.length > 0\"> <div class=\"data-source-message\" *ngIf=\"selectedDataSource && selectedDataSource.refDataSourceKey\"> <div> <button type=\"button\" class=\"fe-btn fe-btn-default fe-btn-save\" (click)=\"openImportBoxDataModalClick()\">{{lc('ImportConfigurationButton')}}</button> </div> <tabset class=\"data-source-tab\" #tabs> <tab heading=\"{{lc('MonitorData')}}\" (selectTab)=\"activeTab($event,0)\"> <raw-variable #rawVariableView *ngIf=\"activeTabIndex==0\" [configureId]=\"configureId\" [dataSourceId]=\"selectedDataSource.id\"></raw-variable> </tab> <tab heading=\"{{lc('AlarmRegistration')}}\" (selectTab)=\"activeTab($event,1)\"> <raw-alarm-registration #rawAlarmRegistrationView *ngIf=\"activeTabIndex==1\" [configureId]=\"configureId\" [dataSourceId]=\"selectedDataSource.id\"></raw-alarm-registration> </tab> <tab heading=\"{{lc('HistoryData')}}\" (selectTab)=\"activeTab($event,2)\"> <raw-history-data #rawHistoryDataView *ngIf=\"activeTabIndex==2\" [configureId]=\"configureId\" [dataSourceId]=\"selectedDataSource.id\"></raw-history-data> </tab> <tab heading=\"{{lc('EdgeComputing')}}\" (selectTab)=\"activeTab($event,3)\"> <raw-edge-computing #rawEdgeComputing *ngIf=\"activeTabIndex==3\" [configureId]=\"configureId\" [dataSourceId]=\"selectedDataSource.id\"></raw-edge-computing> </tab> </tabset> </div> <div class=\"no-import-configuration\" *ngIf=\"selectedDataSource && !selectedDataSource.refDataSourceKey\"> <div> <div class=\"icon-no-data\"> <i class=\"fcloud-nodata-dashboard\"></i> </div> <div>{{lc('CurrentDataSourceNoConfigured')}}</div> <button type=\"button\" class=\"fe-btn fe-btn-default fe-btn-save\" (click)=\"openImportBoxDataModalClick()\">{{lc('ImportConfigurationButton')}}</button> </div> </div> </div> <div class=\"no-import-configuration\" *ngIf=\"dataSources.length < 1\"> <div> <div class=\"icon-no-data\"> <i class=\"fcloud-nodata-dashboard\"></i> </div> <div>{{lc(\"NoDataSourceAdded\")}}</div> </div> </div> </div> </div> <importBoxDataModal #importBoxDataModal (importAction)=\"importFromBox($event)\" (importAndGenerateAction)=\"importFromBoxAndGenerate($event)\"></importBoxDataModal> <fc-fbox-account-warning #fboxAccountWarningModal></fc-fbox-account-warning> </div>",
            styles: [".design-data-source-configuration{ .data-source-table-container { width: 100%; height: calc(100vh - 46px); .data-source-list { position: absolute; left: 0px; width: 200px; height: calc(100% - 46px); float: left; border-right: 1px solid #DCDEE3; .data-source-list-title { height: 50px; border-bottom: 1px solid #DCDEE3; display: flex; justify-content: flex-start; align-items: flex-end; span { padding: 5px; padding-left: 20px; font-size: 16px; font-weight: 300; color: #000000; } } .data-source-list-content { width: 100%; height: calc(100% - 50px); padding: 20px; .add-data-source { width: 100%; height: 32px; cursor: pointer; border: 1px solid #3695ff; color: #3695ff; text-align: center; margin-bottom: 10px; line-height: 32px; background-color: #ffffff; transition: background-color 0.2s ease-in; } .add-data-source:hover { background-color: #3695ff; color: #fff; } } .data-source { width: 100%; height: 32px; cursor: pointer; color: rgba(0, 0, 0, 0.9); position: relative; .icon { width: 32px; padding: 7px; height: 100%; text-align: center; display: none; float: left; } .data-source-name { width: calc(100% - 32px); height: 100%; padding-left: 10px; line-height: 32px; display: block; float: left; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; } .operations { width: 150px; position: fixed; background: #ffffff; box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.3); z-index: 999; display: none; div { padding: 8px 16px; color: #000000; cursor: pointer; } div:hover { background: #EEF3F9; color: #3695ff; } } } .data-source:hover { background: #F2F3F7; .icon { display: block; background: #EBECF0; } } .data-source.active { background: #3695ff; color: #fff; .icon { background: #3695ff; } .icon:hover { background: #226bbc; } .icon.active { display: block; background: #226bbc; } } } .data-source-content { width: calc(100% - 200px); float: left; height: 100%; padding: 20px; overflow: auto; margin-left: 200px; .no-import-configuration { width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; color: rgba(0, 0, 0, 0.3); font-size: 14px; text-align: center; .fcloud-nodata-dashboard { font-size: 140px; color: rgba(0, 0, 0, 0.3); margin-bottom: 12px; } .fe-btn-save { margin-top: 20px; } } .data-source-message { width: 100%; height: 100%; padding: 20px; ::ng-deep .tab-content { height: calc(100% - 100px); } } } } .data-source-tab>.nav.nav-tabs { .nav-link { color: #fff; } } .data-source-list-body { height: calc(100% - 42px); overflow-x: hidden; overflow-y: auto; } .data-source-tab>.nav.nav-tabs { margin: 0; padding: 3px 0px 0px 0px; border: none; display: -webkit-box; display: -ms-flexbox; display: inline-block; -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center; width: 100%; border-bottom: 1px solid #ddd; .nav-item { margin-right: 20px; } } .data-source-tab>.nav-tabs>li { float: none; display: inline-block; } .data-source-tab>.nav-tabs>li>a { padding: 10px; color: black !important; border: none; background-color: transparent; font-size: 16px; } .data-source-tab>.nav-tabs>li.active>a, .data-source-tab>.nav-tabs>li.active>a:hover, .data-source-tab>.nav-tabs>li.active>a:focus { padding: 10px; color: #3695ff !important; border-bottom-color: #3695ff; background-color: transparent; border: none; border-bottom: 4px solid #3695ff; } .has-data-source { width: 100%; height: 100%; } .scroll-body { width: 100%; height: 100%; } }"],
            encapsulation: ViewEncapsulation.None,
            animations: [appModuleAnimation()]
        })
    ], DataSourceConfigurationComponent);
    return DataSourceConfigurationComponent;
}(ConfigureComponentBase));
export { DataSourceConfigurationComponent };
